import React, { useContext, useEffect, useState } from "react";


import { withTranslation } from "react-i18next";
import { getPayboxParameters } from "../../../utils/requests/paybox";
import { MsalInstanceContext, VariablesContext } from "../../../auth/AppProvider";
import * as FormsComponent from "../index";
import { PencilIcon } from "@heroicons/react/24/outline";
import LoadingSpinner from "../../loading/LoadingSpinner";
import Alert from "../alert/Alert";
import { CompletionsContext, ContactIdContext } from "../../../App";
const countrycodes = require('../../../assets/countrycode.json');


const errorList = {
    "00000": " Opération réussie / Operation successful",
    "00001": "La connexion au centre d’autorisation a échoué ou une erreur interne est survenue / The connection to the authorization center has failed or an internal error has occurred",
    "00002": "Une erreur de cohérence est survenue / An inconsistency error has occurred",
    "00003": "Erreur Paybox / Paybox error",
    "00004": "Numéro de porteur ou cryptogramme visuel invalide / Invalid card number or visual cryptogram",
    "00006": "Accès refusé ou site/rang/identifiant incorrect / Access denied or incorrect site/rank/identifier",
    "00008": "Date de fin de validité incorrecte / Incorrect end date of validity",
    "00010": "Devise inconnue / Unknown currency",
    "00011": "Montant incorrect / Incorrect amount",
    "00012": "Référence commande invalide / Invalid order reference",
    "00013": "Cette version n’est plus soutenue / This version is no longer supported",
    "00014": "Trame reçue incohérente / Received frame inconsistent",
    "00015": "Émetteur de carte inconnu / Unknown card issuer",
    "00016": "Référence de paiement invalide / Invalid payment reference",
    "00021": "Carte non autorisée / Card not authorized",
    "00022": "Plafond atteint / Limit reached",
    "00029": "Carte non conforme / Non-compliant card",
    "99999": "",
    "00097": "Timeout de connexion atteint / Connection timeout reached",
    "00098": "Erreur de connexion interne / Internal connection error",
    "canceled": "Paiement annulé / Payment canceled",

}

const currencyList = [{ "option": "978", "label": "€" }, { "option": "840", "label": "$" }, { "option": "826", "label": "£" }]

function Paybox({ t, question, formId }) {
    const variables = useContext(VariablesContext)
    const msalInstance = useContext(MsalInstanceContext);
    const [errorShow, setErrorShow] = useState(false);
    const [payboxParameters, setPayboxParameters] = useState(false);
    const [formType, setFormType] = useState(false);
    const [lockInfo, setLockInfo] = useState(false);
    const [errors, setErrors] = useState(null);
    const [completions, setCompletions] = useContext(CompletionsContext);
    const contactId = useContext(ContactIdContext);

    const [formBuyer, setFormBuyer] = useState({
        firstName: "",
        lastName: "",
        email: "",
        adress1: "",
        adress2: "",
        zipCode: "",
        city: "",
        country: ""
    })




    useEffect(() => {
        if (window.location.href.endsWith("/paid")) {
            setErrorShow(true);
        }
        var formTypeLoc = window.location.href.split("/")[3];

        setFormType(decodeURI(formTypeLoc));

    }, [])

    function getParameters() {
        var completion = null;
        if (completions) {
            completion = completions.find(c => c.id === formId);
        }
        setErrors(null);
        if (formBuyer.firstName === "" || formBuyer.lastName === "" || formBuyer.email === "" || formBuyer.adress1 === "" || formBuyer.zipCode === "" || formBuyer.city === "" || formBuyer.country === "") {
            setErrors(t("Please fill all required fields"));
        } else {
            if (completion === null) {
                setErrors(t("An error occurred while retrieving your application. Please try again later."));
                return;
            }
            setLockInfo(true);
            setPayboxParameters(false);
            setErrorShow(false);
            getPayboxParameters(msalInstance, variables, completion, question.id, contactId, formBuyer).then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    return res.json().then(err => {
                        if (err && err.noteError) {
                            setErrors([err.message]);
                            completion.noteError = err.noteError;
                            var Completions = completions.filter(c => c.id !== completion.id);
                            setCompletions([...Completions, completion]);
                        } else {
                            setErrors([err]);
                        }
                        throw err;
                    });
                }
            }).then(data => {
                setPayboxParameters(data);
            }).catch(err => {
                if (err != null && typeof err === "string")
                    setErrors([err]);
                else if (err && err.message)
                    setErrors([err.message]);
                else
                    setErrors([t("Please refresh the page and try again")]);
                setLockInfo(false);
            })
        }
    }



    var completion = completions?.find(c => c.id === formId);

    return question ? <div>
        {question?.value === "paid" || question?.options[0]?.value === "0" ?
            <div className="mt-6">
                <div className="border bg-white p-6" style={{ borderRadius: '20px', borderColor: '#eceef2', boxShadow: 'rgba(16, 20, 34, 0.15) 0px 12px 30px -20px' }}>
                    <table className="w-full text-sm">
                        <tbody className="divide-y divide-gray-100">
                            {completion?.label && <tr>
                                <td className="py-3 text-gray-400">{t("Programme")}</td>
                                <td className="py-3 text-right font-medium text-gray-900">{completion?.label}</td>
                            </tr>}
                            <tr>
                                <td className="py-3 text-gray-400">{t("Montant réglé")}</td>
                                <td className="py-3 text-right font-medium text-gray-900">
                                    {question?.options[0]?.value === "0" ? t("Gratuit") : <>
                                        {question?.options[0]?.value ? (question?.options[0]?.value.slice(question?.options[0]?.value.length - 2) !== "00" ? [question?.options[0]?.value.slice(0, question?.options[0]?.value.length - 2), ",", question?.options[0]?.value.slice(question?.options[0]?.value.length - 2)].join('') : question?.options[0]?.value.slice(0, question?.options[0]?.value.length - 2)) : null}
                                        {question?.options[1]?.value && currencyList.find(cL => cL.option === question?.options[1]?.value) ? " " + currencyList.find(cL => cL.option === question?.options[1]?.value)?.label : null}
                                    </>}
                                </td>
                            </tr>
                            <tr>
                                <td className="py-3 text-gray-400">{t("Statut")}</td>
                                <td className="py-3 text-right font-semibold text-green-600">{t("Confirmé")}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            : (question?.value === "waiting" ?
                <div className="mt-6">
                    <Alert type="info" title={t("En attente de paiement")} description={t("Nous attendons la réponse de Paybox concernant votre paiement. Revenez plus tard.")} />
                </div> : (errorShow ?
                    <div className="mt-6">
                        <Alert type="error" title={t("Une erreur est survenue lors de votre paiement")} description={errorList[question?.value]} />
                    </div>
                    : null))}
        {question?.value === "paid" || question?.options[0]?.value === "0" ? <div className="text-center items-center align-middle py-auto place-content-center text-2xl px-24 ">
        </div> : (question?.value !== "waiting" ? <div className="mt-6">

            <div className="grid grid-cols-1 md:grid-cols-[1.2fr_1fr] gap-6">
                {/* Billing form card */}
                <div className="bg-white p-6">
                    <div className="flex items-center justify-between mb-5">
                        <h2 className="text-base font-bold text-gray-900">{t("Billing information")}</h2>
                        {lockInfo && <PencilIcon className="h-5 w-5 text-gray-400 cursor-pointer hover:text-gray-600 transition-colors" onClick={() => setLockInfo(false)} />}
                    </div>
                    {!lockInfo ? <div className="space-y-4">
                        {errors ? <div className="text-red-500 text-sm">{errors}</div> : null}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div>
                                <label className="text-[13px] font-medium flex items-center gap-1 mb-1.5" style={{ color: '#3a4250' }}>{t("Firstname label required")}</label>
                                <FormsComponent.Input id="firstName" value={formBuyer.firstName} onChange={(e) => setFormBuyer({ ...formBuyer, firstName: e })} />
                            </div>
                            <div>
                                <label className="text-[13px] font-medium flex items-center gap-1 mb-1.5" style={{ color: '#3a4250' }}>{t("Lastname label required")}</label>
                                <FormsComponent.Input id="lastName" value={formBuyer.lastName} onChange={(e) => setFormBuyer({ ...formBuyer, lastName: e })} />
                            </div>
                        </div>
                        <div>
                            <label className="text-[13px] font-medium flex items-center gap-1 mb-1.5" style={{ color: '#3a4250' }}>{t("Email label required")}</label>
                            <FormsComponent.Input id="email" value={formBuyer.email} onChange={(e) => setFormBuyer({ ...formBuyer, email: e })} />
                        </div>
                        <div>
                            <label className="text-[13px] font-medium flex items-center gap-1 mb-1.5" style={{ color: '#3a4250' }}>{t("Address label required")}</label>
                            <FormsComponent.Input id="adress1" value={formBuyer.adress1} onChange={(e) => setFormBuyer({ ...formBuyer, adress1: e })} />
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                            <div>
                                <label className="text-[13px] font-medium flex items-center gap-1 mb-1.5" style={{ color: '#3a4250' }}>{t("City label required")}</label>
                                <FormsComponent.Input id="city" value={formBuyer.city} onChange={(e) => setFormBuyer({ ...formBuyer, city: e })} />
                            </div>
                            <div>
                                <label className="text-[13px] font-medium flex items-center gap-1 mb-1.5" style={{ color: '#3a4250' }}>{t("Zip code label required")}</label>
                                <FormsComponent.Input id="zipCode" value={formBuyer.zipCode} onChange={(e) => setFormBuyer({ ...formBuyer, zipCode: e })} />
                            </div>
                            <div>
                                <label className="text-[13px] font-medium flex items-center gap-1 mb-1.5" style={{ color: '#3a4250' }}>{t("Country label required")}</label>
                                <select id="country" className="block w-full text-sm bg-white border border-primary rounded-[11px] h-[46px] px-3.5 focus:outline-none transition-colors"
                                    onChange={(e) => setFormBuyer({ ...formBuyer, country: e.target.value })}
                                    value={formBuyer.country}>
                                    <option value=""></option>
                                    {countrycodes.map(c => ({ label: c.name, value: c["country-code"] })).map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                                </select>
                            </div>
                        </div>
                    </div> : <div className="text-sm text-gray-600 space-y-1">
                        <p className="font-medium">{formBuyer.firstName} {formBuyer.lastName}</p>
                        <p className="text-gray-400">{formBuyer.email}</p>
                        <p className="text-gray-400">{formBuyer.adress1}, {formBuyer.zipCode} {formBuyer.city}</p>
                        <p className="text-gray-400">{countrycodes.find(c => c["country-code"] === formBuyer.country)?.name}</p>
                    </div>}

                    {!lockInfo && <button
                        type="button"
                        onClick={getParameters}
                        className="mt-6 w-full inline-flex items-center justify-center px-5 py-3 text-base font-semibold text-white hover:opacity-95 transition-opacity"
                        style={{ backgroundColor: "var(--primary-color)", borderRadius: '11px' }}
                    >
                        {t("Enregistrer")}
                    </button>}
                </div>

                {/* Summary card */}
                <div className="border bg-white p-6 self-start" style={{ borderRadius: '20px', borderColor: '#eceef2', boxShadow: 'rgba(16, 20, 34, 0.15) 0px 12px 30px -20px' }}>
                    <h2 className="text-base font-bold text-gray-900 mb-5">{t("Récapitulatif du paiement")}</h2>
                    <div className="border-t border-gray-100 pt-4">
                        <div className="flex items-center justify-between text-2xl font-bold text-gray-900">
                            <span className="text-sm font-medium text-gray-500">{t("À régler aujourd'hui")}</span>
                            <span>
                                {question?.options[0]?.value ? (question?.options[0]?.value.slice(question?.options[0]?.value.length - 2) !== "00" ? [question?.options[0]?.value.slice(0, question?.options[0]?.value.length - 2), ",", question?.options[0]?.value.slice(question?.options[0]?.value.length - 2)].join('') : question?.options[0]?.value.slice(0, question?.options[0]?.value.length - 2)) : null}
                                {question?.options[1]?.value && currencyList.find(cL => cL.option === question?.options[1]?.value) ? " " + currencyList.find(cL => cL.option === question?.options[1]?.value)?.label : null}
                            </span>
                        </div>
                    </div>

                    {payboxParameters && lockInfo ? <form method="POST" action={payboxParameters.options.find(opt => opt.label === "url")?.value?.split(" ")[0]}>
                        {payboxParameters.options.filter(opt => opt.label !== "url").sort((a, b) => parseFloat(a.displayOrder) - parseFloat(b.displayOrder)).map(opt => <input key={opt.label} type="hidden" name={opt.label} value={opt.value} />)}
                        <button
                            type="submit"
                            className="mt-6 w-full inline-flex items-center justify-center px-5 py-3 text-base font-semibold text-white hover:opacity-95 transition-opacity"
                            style={{ backgroundColor: "var(--primary-color)", borderRadius: '11px' }}
                        >
                            {t("Procéder au paiement")} {question?.options[0]?.value ? (question?.options[0]?.value.slice(question?.options[0]?.value.length - 2) !== "00" ? [question?.options[0]?.value.slice(0, question?.options[0]?.value.length - 2), ",", question?.options[0]?.value.slice(question?.options[0]?.value.length - 2)].join('') : question?.options[0]?.value.slice(0, question?.options[0]?.value.length - 2)) : null}{question?.options[1]?.value && currencyList.find(cL => cL.option === question?.options[1]?.value) ? " " + currencyList.find(cL => cL.option === question?.options[1]?.value)?.label : null}
                        </button>
                    </form> : lockInfo && !payboxParameters ? <div className="mt-6 flex justify-center"><LoadingSpinner /></div> : <button
                        type="button"
                        disabled
                        className="mt-6 w-full inline-flex items-center justify-center px-5 py-3 text-base font-semibold text-white opacity-40 cursor-not-allowed"
                        style={{ backgroundColor: "var(--primary-color)", borderRadius: '11px' }}
                    >
                        {t("Procéder au paiement")}
                    </button>}

                    <p className="mt-3 text-xs text-center text-gray-400">🔒 {t("Paiement sécurisé")}</p>
                </div>
            </div>

        </div> : null)
        }
    </div > : null
}

export default withTranslation()(Paybox);